__turbopack_context__.v({
  "content": "styles-module-scss-module__VnRWra__content",
  "root": "styles-module-scss-module__VnRWra__root",
});
